import { Navigate } from 'react-router-dom';
import { useUserProfile } from '../../contexts/user/hooks';

interface OwnerRouteProps {
    children: React.ReactNode;
}

const OwnerRoute: React.FC<OwnerRouteProps> = ({ children }) => {
    const { profile, isLoading } = useUserProfile();

    // Check if there's a token in localStorage
    const hasToken = !!localStorage.getItem('authToken');

    // If we have a token but no profile yet, we're still loading user data
    // This handles the race condition where routes render before App.tsx useEffect runs
    if (hasToken && !profile) {
        return (
            <div className="flex items-center justify-center min-h-screen">
                <div className="text-gray-600 dark:text-gray-400">Loading...</div>
            </div>
        );
    }

    // Wait for user data to load before checking role
    if (isLoading) {
        return (
            <div className="flex items-center justify-center min-h-screen">
                <div className="text-gray-600 dark:text-gray-400">Loading...</div>
            </div>
        );
    }

    // Check if user is owner
    const isOwner = profile && (profile as any)?.role === 'owner';

    if (!isOwner) {
        // Redirect non-owner users to dashboard
        return <Navigate to="/" replace />;
    }

    return <>{children}</>;
};

export default OwnerRoute;
